import styled from 'styled-components';

export const VehicleTypeContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};

  span {
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;
